import React from 'react'
import './SessionTags.scss'

export interface ISessionTags {
  containerClassName?: string
  accessDeniedReason: string | undefined
  hasCustomerWeighedItems: boolean
  hasMultipleCompletedPayments: boolean
  hasRemovedItems: boolean
  isMissingPayment: boolean
  isSessionFlagged: boolean
  isCustomerFlagged: boolean
}

export default function SessionTags({ containerClassName, accessDeniedReason, hasCustomerWeighedItems, hasMultipleCompletedPayments, hasRemovedItems, isMissingPayment, isSessionFlagged, isCustomerFlagged  } : ISessionTags) {
  const accessDeniedReasonTranslation = {
    AgeAccessDenied: 'Nekad p.g.a. ålderskrav',
    DoorAccessDenied: 'Spärrad',
    NotStammisAccessDenied: 'Nekad p.g.a. icke-stammis',
    OpenHoursAccessDenied: 'Nekad p.g.a. anpassade öppettider',
    PostalCodeAccessDenied: 'Nekad p.g.a. postnummerkrav',
  }

  return (
    <div className={`session-tags__container flex flex-wrap${containerClassName ? ' ' + containerClassName : ''}`}>
      {accessDeniedReason && <div className='session-tags__tag'>{accessDeniedReasonTranslation[accessDeniedReason as keyof typeof accessDeniedReasonTranslation]}</div>}
      {hasCustomerWeighedItems && <div className='session-tags__tag'>Viktvara</div>}
      {hasMultipleCompletedPayments && <div className='session-tags__tag'>Flera betalningar</div>}
      {hasRemovedItems && <div className='session-tags__tag'>Borttagning av vara</div>}
      {isMissingPayment && <div className='session-tags__tag'>Saknar Betalning</div>}
      {isSessionFlagged && <div className='session-tags__tag'><div className='flex items-center gap-1'><tgdb-ica-icon-info style={{ fontSize: '12px' }} />Flaggat kundvarv</div></div>}
      {isCustomerFlagged && <div className='session-tags__tag'><div className='flex items-center gap-1'><tgdb-ica-icon-info style={{ fontSize: '12px' }} />Flaggad kund</div></div>}
    </div>
  )
}
